import React from 'react';
import { ContentCopy, CheckCircle } from '@mui/icons-material';

const InstallationGuide = ({ language }) => {
    const [copied, setCopied] = React.useState(false);

    const installationCommands = {
        javascript: {
            packageManager: 'npm',
            command: 'npm install @netikash/sdk',
            alternatives: [
                { manager: 'yarn', command: 'yarn add @netikash/sdk' },
                { manager: 'pnpm', command: 'pnpm add @netikash/sdk' }
            ]
        },
        python: {
            packageManager: 'pip',
            command: 'pip install netikash-sdk',
            alternatives: [
                { manager: 'poetry', command: 'poetry add netikash-sdk' }
            ]
        },
        php: {
            packageManager: 'composer',
            command: 'composer require netikash/sdk',
            alternatives: []
        },
        rest: {
            packageManager: 'curl',
            command: '# Utilisation directe via REST API',
            alternatives: []
        },
        ios: {
            packageManager: 'CocoaPods',
            command: 'pod \'NetikashSDK\'',
            alternatives: [
                { manager: 'SwiftPM', command: 'Package.swift' }
            ]
        },
        android: {
            packageManager: 'Gradle',
            command: 'implementation \'com.netikash:sdk:1.4.0\'',
            alternatives: []
        }
    };

    const currentCommand = installationCommands[language] || installationCommands.javascript;

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Erreur de copie:', err);
        }
    };

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Installation</h3>

            <div className="bg-gray-900 rounded-lg p-4 mb-4">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-400 text-sm">{currentCommand.packageManager}</span>
                    <button
                        onClick={() => copyToClipboard(currentCommand.command.replace('# ', ''))}
                        className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors text-sm"
                    >
                        {copied ? (
                            <>
                                <CheckCircle className="text-green-400 text-base" />
                                <span>Copié !</span>
                            </>
                        ) : (
                            <>
                                <ContentCopy className="text-base" />
                                <span>Copier</span>
                            </>
                        )}
                    </button>
                </div>
                <pre className="text-green-400 text-sm overflow-x-auto">
          <code>{currentCommand.command}</code>
        </pre>
            </div>

            {currentCommand.alternatives.length > 0 && (
                <div>
                    <h4 className="font-medium text-gray-900 mb-3">Autres gestionnaires de paquets</h4>
                    <div className="space-y-2">
                        {currentCommand.alternatives.map((alt, index) => (
                            <div key={index} className="flex items-center justify-between bg-gray-50 rounded-lg p-3">
                                <div>
                                    <span className="text-sm font-mono text-gray-600">{alt.manager}</span>
                                    <pre className="text-sm text-gray-800 mt-1">{alt.command}</pre>
                                </div>
                                <button
                                    onClick={() => copyToClipboard(alt.command)}
                                    className="text-gray-400 hover:text-gray-600"
                                >
                                    <ContentCopy className="text-base" />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Dependencies */}
            <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <h4 className="font-medium text-amber-900 mb-2">Dépendances</h4>
                <ul className="text-sm text-amber-800 space-y-1">
                    <li>• Node.js 14+ (pour JavaScript)</li>
                    <li>• Python 3.7+ (pour Python)</li>
                    <li>• PHP 7.4+ (pour PHP)</li>
                    <li>• iOS 13+ (pour iOS)</li>
                    <li>• Android API 21+ (pour Android)</li>
                </ul>
            </div>
        </div>
    );
};

export default InstallationGuide;